import { RegisterSection } from './RegisterSection'

export type RegisterPage = Record<string, never>

export const RegisterPage = (): React.ReactElement => {
  return <RegisterSection />
}
